export default __webpack_public_path__ + "static/media/profit.9a4d290b.svg";